<template>
  <section class="cn-about-image">
    <div class="container">
      <div class="cn-about-image__content">
        <UiIconYouCan class="cn-about-image__svg" />
        <div class="cn-about-image__image">
          <CdnImg
            :src="data.image.src"
            format="webp"
            :width="1280"
            :height="603"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import UiIconYouCan from '@/components/ui/icons/UiIconYouCan';

interface Props {
  data: {
    image: {
      src: string;
    };
  };
}
defineProps<Props>();
</script>

<style lang="scss">
.cn-about-image {
  --ab-canyon-about-image-svg-color: var(--ab-canyon-color-primary);

  padding: var(--size-3xl) 0;

  &__content {
    flex-direction: column;
    display: flex;
    @media (min-width: 656px) {
      align-items: center;
      flex-direction: row;
    }
  }
  &__svg {
    color: var(--ab-canyon-about-image-svg-color);

    flex-shrink: 0;
    width: calc(6 * var(--size-base));
    height: calc(6 * var(--size-base));
    margin-bottom: calc(var(--size-5xl) * -1);
    z-index: 10;
    @media (min-width: 656px) {
      width: calc(14 * var(--size-base));
      height: calc(14 * var(--size-base));
      margin-bottom: 0px;
      margin-right: -115px;
    }
    @media (min-width: 1280px) {
      width: 290px;
      height: 290px;
      margin-right: -150px;
    }
  }
  &__image {
    img {
      width: 100%;
    }
  }
}
</style>
